import { DashboardIcon, FinanceIcon, SettingsIcon, LogoutIcon } from "@trafficsharkdsp/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import cls from "../ui/Header.module.css";

import { ROUTES } from "@/shared/config/router/routes";

export const useGetDropdownItems = (onLogout?: () => void) => {
    const { t } = useTranslation();
    const items = [
        {
            key: "dashboard",
            label: (
                <Link to={ROUTES.CAMPAIGNS}>
                    <div className={cls["item-wrapper"]}>
                        <DashboardIcon />
                        <span>{t("header.user-dropdown.dashboard")}</span>
                    </div>
                </Link>
            ),
        },
        {
            key: "finance",
            label: (
                <Link to={ROUTES.FINANCES}>
                    <div className={cls["item-wrapper"]}>
                        <FinanceIcon />
                        <span>{t("header.user-dropdown.finance")}</span>
                    </div>
                </Link>
            ),
        },
        {
            key: "profile_settings",
            label: (
                <Link to={ROUTES.PROFILE}>
                    <div className={cls["item-wrapper"]}>
                        <SettingsIcon />
                        <span>{t("header.user-dropdown.settings")}</span>
                    </div>
                </Link>
            ),
        },
        {
            key: "divider",
        },
        {
            key: "logout",
            label: (
                <div className={cls["item-wrapper"]}>
                    <LogoutIcon />
                    <span>{t("header.user-dropdown.logout")}</span>
                </div>
            ),
            itemProps: { "data-qa": "logout-button" },
            onClick: onLogout,
        },
    ];
    return items;
};
